import { Loader2 } from 'lucide-react';
import { useDeployStatus } from './useDeployStatus';
import type { DeployComponentName } from './api';

// Friendly labels for the components named in the banner.
const LABELS: Record<DeployComponentName, string> = {
  core: 'Dialer core',
  bff: 'BFF',
  api: 'API',
  web: 'Web app',
};

// Console banner shown while ANY component is mid-deploy (polled from
// /bff/deploy-status, which reads live AWS rollout state). Advisory — operators
// keep working; it just sets expectations that brief reconnects may happen.
export function DeployBanner() {
  const status = useDeployStatus();
  if (!status?.deploying) return null;

  const rolling = status.components.filter((c) => c.deploying).map((c) => LABELS[c.name] ?? c.name);
  if (rolling.length === 0) return null;

  return (
    <div
      className="mb-6 flex items-center gap-3 rounded-md border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-800"
      data-testid="deploy-banner"
      role="status"
    >
      <Loader2 className="h-4 w-4 shrink-0 animate-spin" />
      <span>
        <span className="font-medium">Deployment in progress</span> — {rolling.join(', ')}{' '}
        {rolling.length === 1 ? 'is' : 'are'} rolling out. Active calls keep running; brief
        reconnects are expected while it finishes.
      </span>
    </div>
  );
}
